import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ExtendedListenableSubscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';

import { Permission } from '@benzinga/session';
import { PermissionRestful } from './restful';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'permissions_error';
  type: 'error';
}

interface PermissionsEvent {
  permissions: Permission[];
  type: 'get_permissions';
}

export type PermissionRequestEvent = ErrorEvent | PermissionsEvent;

interface PermissionFunctions {
  getPermissions: PermissionRequest['getPermissions'];
}

export class PermissionRequest extends ExtendedListenableSubscribable<PermissionRequestEvent, PermissionFunctions> {
  private restful: PermissionRestful;

  constructor(session: Session) {
    super();
    this.restful = new PermissionRestful(session);
  }

  public getPermissions = async (): SafePromise<Permission[]> => {
    const permissions = await this.restful.getPermissions();
    if (permissions.err) {
      this.dispatch({
        error: permissions.err,
        errorType: 'permissions_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        permissions: permissions.ok,
        type: 'get_permissions',
      });
    }
    return permissions;
  };

  protected onSubscribe(): PermissionFunctions {
    return {
      getPermissions: this.getPermissions,
    };
  }
}
